import { useEffect, useRef, useState } from 'react';

export function useInterval(func, interval) {
  const [value, setValue] = useState(func);
  const funcRef = useRef();
  funcRef.current = func;
  useEffect(() => {
    const timer = setInterval(() => {
      setValue((current) => funcRef.current(current));
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);
  return value;
}
